import $ from 'jquery';

export default function changeNum() {
  
  function numCamere() {
    var $minus = $('#camere-minus'),
        $plus = $('#camere-plus');
        
    $minus.on('click', function(e) {
      var camere = Number($("#camere").val());
      var changeNum = camere -= 1;
      
			if (changeNum > 0 ) {
				$('#camere').val(changeNum);
        $plus.removeClass('form__btn--disabled');
        
        if (changeNum === 1 ) {
          $minus.addClass('form__btn--disabled');
        }
			} else {
        $minus.addClass('form__btn--disabled');
      }
    });
    
    $plus.on('click', function(e) {
      var camere = Number($("#camere").val());
      var changeNum = camere += 1;
      
			if (changeNum <= 9 ) {
				$('#camere').val(changeNum);
        $minus.removeClass('form__btn--disabled');
        
        if (changeNum === 9 ) {
          $plus.addClass('form__btn--disabled');
        }
			} else {
        $plus.addClass('form__btn--disabled');
      }
    });
  }
  
  function numAdulti() {
    var $minus = $('#adulti-minus'),
        $plus = $('#adulti-plus');
        
    $minus.on('click', function(e) {
      var adulti = Number($("#adulti").val());
      var changeNum = adulti -= 1;
      
			if (changeNum > 0 ) {
				$('#adulti').val(changeNum);
        $plus.removeClass('form__btn--disabled');
        
        if (changeNum === 1 ) {
          $minus.addClass('form__btn--disabled');
        }
			} else {
        $minus.addClass('form__btn--disabled');
      }
    });
    
    $plus.on('click', function(e) {
      var adulti = Number($("#adulti").val());
      var changeNum = adulti += 1;
      
			if (changeNum <= 9 ) {
				$('#adulti').val(changeNum);
        $minus.removeClass('form__btn--disabled');
        
        if (changeNum === 9 ) {
          $plus.addClass('form__btn--disabled');
        }
			} else {
        $plus.addClass('form__btn--disabled');
      }
    });
  }
  
  function numBambini() {
    var $minus = $('#bambini-minus'),
        $plus = $('#bambini-plus');
        
    $minus.on('click', function(e) {
      var bambini = Number($("#bambini").val());
      var changeNum = bambini -= 1;
      
			if (changeNum > -1 ) {
				$('#bambini').val(changeNum);
        $plus.removeClass('form__btn--disabled');
        
        if (changeNum === 0 ) {
          $minus.addClass('form__btn--disabled');
        }
			} else {
        $minus.addClass('form__btn--disabled');
      }
    });
    
    $plus.on('click', function(e) {
      var bambini = Number($("#bambini").val());
      var changeNum = bambini += 1;
      
			if (changeNum <= 12 ) {
				$('#bambini').val(changeNum);
        $minus.removeClass('form__btn--disabled');
        
        if (changeNum === 12 ) {
          $plus.addClass('form__btn--disabled');
        }
			} else {
        $plus.addClass('form__btn--disabled');
      }
    });
  }
  
  if($('#camere-minus').length > 0) {
    $( document ).ready(function() {
      numCamere()
    });
  }
  
  if($('#adulti-minus').length > 0) {
    $( document ).ready(function() {
      numAdulti()
    });
  }
  
  if($('#bambini-minus').length > 0) {
    $( document ).ready(function() {
      numBambini()
    });
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/change-num.js